module.exports = __webpack_public_path__ + "img/white.7ec6b21.svg";